module.exports = __webpack_public_path__ + "img/republicofthecongo.426e373b.svg";